module.exports = __webpack_public_path__ + "img/148ne.55488721.svg";